import axios from "axios"

export async function fetchCsrfToken(): Promise<string> {
  const response = await axios.get("/csrf-token")
  const token = response.data.token

  const metaTag = document.querySelector('meta[name="csrf-token"]')
  if (metaTag instanceof HTMLMetaElement) {
    metaTag.content = token
  }

  return token
}
